export function useAppScrollbar() {

  const toggle = (val: boolean) => {
    const html = document.documentElement;

    if (val && !html.classList.contains('no-scroll')) {
      html.classList.add('no-scroll');
    } else if (!val && html.classList.contains('no-scroll')) {
      html.classList.remove('no-scroll');
    }
  };

  return {
    toggle
  }
}
